export const BLOCKLIST_PAGE_SIZE = 15
export const TXLIST_PAGE_SIZE = 15
export const PENDING_TXLIST_PAGE_SIZE = 15
export const MASTER_TABLE_PAGE_SIZE = 10
